/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";
import { useMemo } from "react";

const headerNavLinkComponents = [
    { componentType: "component.rich-text-with-image", title: "About" },
    { componentType: "component.timeline", title: "Timeline" },
    { componentType: "component.accordion", title: "FAQs" },
    { componentType: "component.embed", title: "Stay Informed" },
];

const useHeaderNavLinks = () => {
    const { model } = useSimpliCity();
    const fields = model?.fields;
    const bodyField = fields?.find((field) => field.name === "body");
    const values = bodyField?.values;
    const components = values && values.length > 0 && values[0].value;

    const headerNavLinks = useMemo(() => {
        const navLinks = [];
        for (let headerNavLinkComponent of headerNavLinkComponents) {
            const { componentType, title } = headerNavLinkComponent;
            const component = components?.find((component) => component.type === componentType);
            if (component) {
                const guid = component?.guid;
                const componentId = `field-component-${guid}`;
                navLinks.push({
                    id: componentId,
                    title
                });
            }
        }
        return navLinks;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, components);

    return headerNavLinks;
};

export { useHeaderNavLinks };
